import { useMemo } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import FoodSectionsNav from "@pages/Food/components/SectionsNav/SectionsNav";
import FoodProfilePageFrame from "@pages/Food/components/FoodProfilePageFrame/FoodProfilePageFrame";
import { FoodSectionEnum } from "@pages/Food/Food.constants";
import useFoodProfilePage from "@pages/Food/hooks/useFoodProfilePage";
import { buildFoodRefreshNavItems } from "@pages/Food/refresh/FoodRefresh.helpers";
import FoodInsightsSummarySection from "@pages/Food/refresh/components/FoodInsightsSummary/FoodInsightsSummary";
import FoodMenuSection from "@pages/Food/refresh/components/FoodMenuSection/FoodMenuSection";
import FoodProfileSidebarLayout from "@pages/Food/refresh/components/FoodProfileSidebarLayout/FoodProfileSidebarLayout";
import FoodRefreshSections from "@pages/Food/refresh/components/FoodRefreshSections/FoodRefreshSections";
// Provides `.Food__section`, which the sections below use; imported here so the page owns its styles.
import "@pages/Food/Food.sections.scss";
import "./FoodRefresh.scss";

/**
 * Food Profile page with the `Food Profile Refresh` flag ON.
 * New and restyled pieces live in `refresh/`; never import from `legacy/` here.
 */
const FoodRefresh: FCX = () => {
    const { isLoading, summary, sectionsWithData, sections } = useFoodProfilePage();
    const navItems = useMemo(() => buildFoodRefreshNavItems(sectionsWithData), [sectionsWithData]);

    return (
        <FoodProfilePageFrame
            rootClassName="FoodRefresh"
            isLoading={isLoading}
            header={(
                // Same page header as Category Profile, without a search box.
                <div className="FoodRefresh__header" data-testid="blockFoodRefreshHeader">
                    <span className="FoodRefresh__header-title">Food Profile</span>
                </div>
            )}
        >
            {/* Above the sidebar and every section: the profile name, then the section links. */}
            <FoodSectionsNav title={summary.name} data={navItems}/>
            <FoodProfileSidebarLayout summary={summary}>
                <FoodInsightsSummarySection word={summary.name}/>
                {/* Menu takes the full row. */}
                <div
                    className="Food__section"
                    id={FoodSectionEnum.Menu}
                    data-testid="blockFoodSectionMenu"
                >
                    <FoodMenuSection summary={summary} menu={sections.menu}/>
                </div>
                <FoodRefreshSections {...sections}/>
            </FoodProfileSidebarLayout>
        </FoodProfilePageFrame>
    );
};

export default FoodRefresh;
